module.exports = __webpack_public_path__ + "static/media/docs.50f99312.txt";


//////////////////
// WEBPACK FOOTER
// ./src/builder/docs.txt
// module id = 848
// module chunks = 0